import React, { useState } from "react";
import { Col, Row } from "antd";
import authArt from '../../../assets/images/auth-art.svg'
import './style.css'
import { useLocation } from "react-router-dom";

const AuthLayout = ({ children }) => {
    const location = useLocation();

    return (
        <>
            <Row className="min-h-screen">
                {/* <Col xs={24} sm={12} md={12} className="bg-primary flex items-center justify-center">
                    <div className="ellipse"></div>
                    <div className="p-8 sm:py-12 md:py-12 sm:px-16 md:px-16">
                        <div className="text-center">
                            <h3 className="heading-3 font-bold">Mobrage</h3>
                            <h4 className="heading-4 font-bold">Your Vehicle Expert Locator App</h4>
                            <p className="text-base text-white pb-6">
                                We are on a mission to connect vehicle experts and vehicle users quickly, efficiently and safely
                            </p>
                            <div className="flex justify-center">
                                <img src={authArt} alt="art" className="img-fluid xl:w-[65%] lg:w-[75%] md:w-[75%] sm:w-[65%] w-[100%]" />
                            </div>
                        </div>
                    </div>
                </Col> */}

                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    className={`bg-white flex items-center justify-center 
                                h-auto
            
            ${location?.pathname?.toLowerCase().includes('signup')
                            ? 'py-[3rem] px-4 sm:px-2'
                            : 'py-[3rem] px-4 sm:px-2'
                        }`}
                >   <div className="">
                        {children}
                    </div>
                </Col>
            </Row>

        </>
    )
}

export default AuthLayout